import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getReportsRequest, getReportsRequestError, getReportsRequestSuccess } from "../../slices/Query/GetReportsSlice";

export const GetReportsApi = (page, limit, status, search) => async (dispatch) => {
    const queryParams = new URLSearchParams({
        page: page,
        limit: limit,
        ...(status && { status }),
        ...(search && { search })
    }).toString();

    const urlWithParams = `${endpoints.getReports}?${queryParams}`;

    try {
        dispatch(getReportsRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getReportsRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getReportsRequestError(_error));
            });
    } catch (error) {
    }
};
